import INSURER_PORTAL_ENTRIES from './insurerPortalEntries';

const ANVA_INSURER_CODE_REGEX = /^\d{10}([A-Z0-9]+)(?=\s|$)/;

const extractAnvaInsurerCode = (value?: Maybe<string>): string | undefined => {
  if (!value) return undefined;

  const normalized = value.trim().toUpperCase();
  const match = normalized.match(ANVA_INSURER_CODE_REGEX);

  return match ? match[1] : undefined;
};

const normalizeInsurerName = (value: string): string =>
  value
    .normalize('NFKD')
    .replace(/[^\w& ]+/g, '')
    .replace(/_/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

const getUrlByCode = (anvaProductRef?: string) => {
  if (!anvaProductRef) return undefined;

  const codeFromRef = extractAnvaInsurerCode(anvaProductRef);

  if (!codeFromRef) return undefined;

  const entry = INSURER_PORTAL_ENTRIES.find((entry) =>
    entry.anvaInsurerCodes?.includes(codeFromRef),
  );

  return entry?.url;
};

const getUrlByName = (insurerName?: string) => {
  if (!insurerName) return undefined;

  const key = normalizeInsurerName(insurerName);

  const entry = INSURER_PORTAL_ENTRIES.find((entry) => entry.name === key);

  return entry?.url;
};

export default function getInsurerPortalUrl({
  insurerName,
  anvaProductRef,
}: {
  insurerName?: string;
  anvaProductRef?: string;
}): string | undefined {
  return getUrlByCode(anvaProductRef) ?? getUrlByName(insurerName);
}
